import TableCell from '@material-ui/core/TableCell';
import React, {useState} from 'react';
import {withStyles} from '@material-ui/core';
import LongTextButton from '../Text/LongTextButton';
import TowLine from '../Text/TwoLine';
import FormaterDate from '../Formater/Date';
import PhoneLinkButton from '../Formater/PhoneLinkButton';
import LinkIconButton from '../Formater/LinkIconButton';
import {DateToString, getContactName} from '../Form/utils';
import iconNames from '../Formater/IconNames';
import Icon from '@material-ui/core/Icon';
import Hidden from '@material-ui/core/Hidden';
import TableRowClickable from '../Form/TableRowClickable';

const RemindCell = ({note, classes}) => (<TowLine
        main={(
            <React.Fragment>
                {note.created_at && (<FormaterDate hour={'2-digit'}
                                                   minute={'2-digit'}
                                                   value={note.created_at}/>)}
                <div className={classes.reminder}>
                    {note.reminder && (<Icon className={classes.reminderIcon}>alarm</Icon>)}
                    {note.reminder && (<FormaterDate hour={'2-digit'}
                                                     minute={'2-digit'}
                                                     value={note.reminder}/>)}
                </div>
            </React.Fragment>
        )}
        sub={
            (<React.Fragment>
                {note.creator && note.creator.name}
            </React.Fragment>)
        }
    />
);

export const ContactData = ({note, classes}) => (
    <TowLine
        main={note.communication_name}
        sub={note.communication_ident ?
            note.communication_ident.includes('@') ? (
                <LinkIconButton
                    text={note.communication_ident}
                    href={`mailto:${note.communication_ident}`}
                    icon={iconNames.email}
                />
            ) : (
                <PhoneLinkButton text={note.communication_ident}/>
            )
            : ''
        }

    />
);

const ContentData = ({note, classes, maxLength}) => (
    <TowLine
        main={note.title}
        sub={(<LongTextButton short={note.content.substr(0, maxLength || 30)} long={note.content}/>)}
    />
);

const LinkingData = ({note, classes}) => (
    <React.Fragment>
        {note.project && (
            <LinkIconButton
                text={note.project.name}
                href={`/project/${note.project.id}`}
                icon={iconNames.project}
            />
        )}
        {note.mailing && (
            <LinkIconButton
                text={note.mailing.name + ' (' + DateToString(note.mailing.created_at) + ')'}
                href={`/mailings/${note.mailing.id}`}
                icon={note.mailing.isOut ? iconNames.mailing_out : iconNames.mailing_in}
            />
        )}
        {note.contact && (
            <LinkIconButton
                text={getContactName(note.contact)}
                href={`/contacts/${note.contact.contact_type}/${note.contact.id}`}
                icon={note.contact.is_company ? iconNames.company : iconNames.contact}
            />
        )}
    </React.Fragment>
);

const NoteListItem = ({note, maxLength, classes, ...rest}) => {
    return (
        <TableRowClickable action={`/notes/${note.id}`}>
            <TableCell className={classes.cellReminder}>
                <RemindCell note={note} classes={classes}/>
            </TableCell>
            <TableCell className={classes.cellContact}>
                <ContactData note={note} classes={classes}/>
            </TableCell>
            <TableCell>
                <ContentData note={note} classes={classes} maxLength={maxLength}/>
            </TableCell>
            <Hidden mdDown>
                <TableCell>
                    <LinkingData note={note} classes={classes}/>
                </TableCell>
            </Hidden>
        </TableRowClickable>
    );
};

const styles = theme => ({
    cellReminder: {
        minWidth: 150,
    },
    cellContact: {
        maxWidth: 250,
    },
    reminder: {
        color: theme.colors.reminder,
    },
    reminderIcon: {
        fontSize: 12,
        paddingRight: theme.spacing.unit,
    },
    spacing: {
        marginTop: theme.spacing.unit * 2,
    },
    span: {
        display: 'inline',
        margin: '0 5px',
    },
});

export default withStyles(styles)(NoteListItem);
